export default __webpack_public_path__ + "static/media/save-icon-black.e068843b.svg";